import React, { useState } from 'react';
import Button from '../Button';
import { StyledDeleteChatHistory } from './DeleteChatHistory.style';

const DeleteChatHistory = ({ onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      onClose();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  return (
    <StyledDeleteChatHistory>
      <h2 className="desc">
        This will permanently delete all your chats, including favorites. This action cannot be undone.
      </h2>
      <div className="btn-holder">
        <Button width="136px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="170px" onClick={() => handleSubmit()} loader={loading}>
          Yes, clear history
        </Button>
      </div>
    </StyledDeleteChatHistory>
  );
};

export default DeleteChatHistory;
